import { useState, useEffect } from "react";
import { useFetch } from "../../../common/hooks/useFetch";
import debounce from "lodash.debounce";
import { listIndicatorsService } from "../services/listIndicators.service";

export const useIndicatorsQuery = (filters) => {
  const fetchData = useFetch();
  const [indicators, setIndicators] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    const fetchIndicators = async () => {
      try {
        setLoading(true);
        const response = await listIndicatorsService(fetchData)(filters);

        setIndicators(response.data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    const debouncedFetch = debounce(fetchIndicators, 500);
    debouncedFetch();
    return () => {
      debouncedFetch.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, filters]);

  return {
    indicators,
    loading,
    refresh: () => setRefresh((prev) => !prev),
  };
};
